/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as o from "react";
import e from "prop-types";
import { validatePackage as k, classNames as n } from "@progress/kendo-react-common";
import { useLocalization as L, provideLocalizationService as R, registerForLocalization as z } from "@progress/kendo-react-intl";
const c = "labels.optional", O = {
  [c]: "(Optional)"
}, N = {
  name: "@progress/kendo-react-labels",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702644685,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/components/my-license/"
}, x = (l) => {
  k(N);
  const { id: t, editorId: s, editorRef: a, editorDisabled: d, children: r, editorValid: g, style: y, className: p, optional: E } = l, m = L(), b = E ? m.toLanguageString(c, O[c]) : "", C = b && /* @__PURE__ */ o.createElement("span", { className: "k-label-optional" }, b), u = o.useCallback(
    (f) => {
      if (a && a.current && !d) {
        a.current.focus && (f.preventDefault(), a.current.focus());
        const i = a.current.actionElement;
        i && (f.preventDefault(), i.click());
      }
    },
    [a]
  ), h = n(
    {
      "k-label": !0,
      "k-label-empty": !r,
      "k-text-error": g === !1,
      "k-text-disabled": d === !0
    },
    p
  );
  return /* @__PURE__ */ o.createElement(
    "label",
    {
      id: t,
      htmlFor: s,
      onClick: u,
      style: y,
      className: h
    },
    r,
    C
  );
};
x.propTypes = {
  id: e.string,
  editorId: e.string,
  editorRef: e.oneOfType([
    e.func,
    e.shape({ current: e.any })
  ]),
  editorValid: e.bool,
  editorDisabled: e.bool,
  style: e.object,
  className: e.string,
  optional: e.bool
};
x.displayName = "KendoReactLabel";
const D = (l) => {
  const t = {
    direction: "start",
    ...l
  };
  k(N);
  const s = n(
    {
      "k-form-error": !0,
      "k-text-start": t.direction === "start",
      "k-text-end": t.direction === "end"
    },
    t.className
  );
  return /* @__PURE__ */ o.createElement(
    "div",
    {
      id: t.id,
      role: "alert",
      style: t.style,
      className: s
    },
    t.children
  );
};
D.propTypes = {
  id: e.string,
  direction: e.oneOf(["start", "end"]),
  children: e.oneOfType([
    e.element,
    e.node
  ]),
  style: e.object,
  className: e.string
};
D.displayName = "KendoReactError";
const T = (l) => {
  const t = {
    direction: "start",
    ...l
  };
  k(N);
  const s = n(
    {
      "k-form-hint": !0,
      "k-text-start": t.direction === "start",
      "k-text-end": t.direction === "end",
      "k-text-disabled": t.editorDisabled === !0
    },
    t.className
  );
  return /* @__PURE__ */ o.createElement(
    "div",
    {
      id: t.id,
      style: t.style,
      className: s
    },
    t.children
  );
};
T.propTypes = {
  id: e.string,
  direction: e.oneOf(["start", "end"]),
  children: e.oneOfType([
    e.element,
    e.node
  ]),
  style: e.object,
  className: e.string,
  editorDisabled: e.bool
};
T.displayName = "KendoReactHint";
class v extends o.Component {
  constructor(t) {
    super(t), this.state = {
      focused: !1
    }, this.handleFocus = (s) => {
      this.setState({ focused: !0 });
    }, this.handleBlur = (s) => {
      this.setState({ focused: !1 });
    }, k(N);
  }
  /**
   * @hidden
   */
  render() {
    const { label: t, editorId: s, className: a, labelClassName: d, editorValue: r, editorPlaceholder: g, editorValid: y, editorDisabled: p, style: E, id: m, optional: b } = this.props, C = R(this), u = b ? C.toLanguageString(c, O[c]) : "", h = u && /* @__PURE__ */ o.createElement("span", { className: "k-label-optional" }, u), f = n(
      {
        "k-floating-label-container": !0,
        "k-focus": this.state.focused,
        "k-empty": !g && !r && r !== 0,
        "k-text-disabled": p,
        "k-rtl": this.props.dir === "rtl"
      },
      a
    ), i = n(
      {
        "k-label": !0,
        "k-text-error": y === !1,
        "k-text-disabled": p
      },
      d
    );
    return /* @__PURE__ */ o.createElement(
      "span",
      {
        id: this.props.id,
        className: f,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        style: E,
        dir: this.props.dir
      },
      this.props.children,
      t ? s ? /* @__PURE__ */ o.createElement("label", { id: m, htmlFor: s, className: i }, t, h) : /* @__PURE__ */ o.createElement("span", { id: m, className: i }, t, h) : null
    );
  }
}
v.propTypes = {
  label: e.string,
  editorId: e.string,
  editorValue: e.oneOfType([e.string, e.bool, e.number]),
  editorPlaceholder: e.string,
  editorValid: e.bool,
  editorDisabled: e.bool,
  id: e.string,
  style: e.object,
  className: e.string,
  labelClassName: e.string,
  optional: e.bool
};
z(v);
export {
  D as Error,
  v as FloatingLabel,
  T as Hint,
  x as Label
};
